import React from 'react';
import { Form, Button, Modal } from 'react-bootstrap';

function MyVerticallyCenteredModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Mensaje enviado exitosamente
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4>¡Gracias!</h4>
                <p>
                    Este form hace parte de este pequeño témplate hecho a base de bootstrap con react, muchas gracias por probarlo.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-info" onClick={props.onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
}

function Contacto() {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <React.Fragment>
            <section className='tusalud-contacto'>
                <h1><span className='logo'>&nbsp;TU&nbsp;</span>SALUD <br /> <span className='subtitle'>Contacto</span></h1>
            </section>

            <section className='resumen'>
                <div className='title-center'>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control type="text" placeholder="Nombre completo" />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Correo</Form.Label>
                            <Form.Control type="email" placeholder="james@tusalud.com" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="disabledSelect">¿Qué tipo de información deseas?</Form.Label>
                            <Form.Select >
                                <option>Salud en general</option>
                                <option>Alimentación</option>
                                <option>Ejercicio</option>
                                <option>Otro</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="Check me out" />
                        </Form.Group>
                        <Button variant="outline-info" onClick={() => setModalShow(true)}>
                            Enviar
                        </Button>
                    </Form>
                    <MyVerticallyCenteredModal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                    />
                </div>
            </section>
        </React.Fragment>
    );


}
export default Contacto;